// language=SQL format=false
export const v3UpgradeStatements = [
    `CREATE TABLE IF NOT EXISTS power_of_one_stores (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        store_external_id TEXT NOT NULL
     );`,
];
